// extracted by mini-css-extract-plugin
export default {"error-body":"Error_error-body__+CzMk","not-found-cloud":"Error_not-found-cloud__gl--+","not-found-text":"Error_not-found-text__YZ4u2","home-btn":"Error_home-btn__LkIRw"};